var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBehavioralHealthColor = function SvgBehavioralHealthColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 60 60",
    "aria-hidden": true,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E5F5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#078708",
    fillRule: "evenodd",
    d: "M29.998 24.475a3.19 3.19 0 0 1-3.2-3.2 3.19 3.19 0 0 1 3.2-3.2 3.19 3.19 0 0 1 3.2 3.2 3.19 3.19 0 0 1-3.2 3.2Zm11.2 10.5c.2.575-.1 1.225-.675 1.45a1.158 1.158 0 0 1-1.4-.5c-1.325-2.375-2.775-4.25-4.375-5.125l-.8 4.075c2.275 1.15 4.275 1.65 5.2 2.875 1.025 1.35.65 2.925-1.1 3.55-1.2.425-2.75.7-4.525.7-1.775 0-3.8-.25-5.9-.9-.1-1.425 2.725-3.525 6.3-3.275.125 0 .25-.075.275-.225.05-.125-.05-.275-.2-.325-4.15-1.075-8.725.775-8.6 3.975-1 .05-2.2.05-3.025-.225-1.5-.5-2.125-1.925-1.1-3.275.925-1.225 3.2-1.725 5.475-2.9l-.8-3.975c-1.95.825-3.75 2.75-5.1 5.125-.3.55-1 .75-1.55.425a1.166 1.166 0 0 1-.5-1.375l.025-.025c1.05-2.8 2.5-6.375 5.9-7.95 1.625-.75 3.575-1 5.525-1 1.875 0 3.85.175 5.45 1 2.95 1.5 4.325 4.7 5.5 7.875v.025Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBehavioralHealthColor);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;